<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-input v-model="params.searchValue" class="input-with-select" size="small">
				        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
				            <el-option label="推送人ID" :value="1"></el-option>
				            <el-option label="推送人名称" :value="2"></el-option>
				        </el-select>
				    </el-input>
				</el-col>
                <el-col :xs="24" :sm="12" :md="16" :lg="12" :xl="8">
                    <div class="clearfix timeType">
                        <el-input class="input-with-select fl" size="small">
                            <el-select v-model="params.timeType" slot="prepend" placeholder="请选择">
                                <el-option label="推送时间" :value="1"></el-option>
                            </el-select>
                        </el-input>
                        <el-date-picker
                            v-model="datetimerange"
                            type="datetimerange"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            class="fl"
                            size="small"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']"
                            align="right"
                            unlink-panels
                            >
                        </el-date-picker>
                    </div>
                </el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-select v-model="params.status" placeholder="请选择" size="small">
				        <el-option label="仅看待审核的" :value="0"></el-option>
				        <el-option label="仅看已通过的" :value="1"></el-option>
						<el-option label="仅看已拒绝的" :value="2"></el-option>
				        <el-option label="不限制状态" value=""></el-option>
				    </el-select>
				</el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="status" label="状态" >
                    <template slot-scope="scope">
                        <span v-if="scope.row.status==0">待审核</span>
                        <span v-else-if="scope.row.status==1" class="color-success">已通过</span>
                        <span v-else-if="scope.row.status==2" class="color-danger">已拒绝</span>
                    </template>
                </el-table-column>
                <el-table-column prop="title" label="标题" min-width="200" show-overflow-tooltip></el-table-column>
				<el-table-column prop="pushUser" label="推送人"></el-table-column>
				<el-table-column prop="business" label="关联业务"></el-table-column>
				 <el-table-column prop="pushTime" label="推送时间" min-width="150"></el-table-column>
                <el-table-column fixed="right" label="操作" width="80">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/push/manage/audit') && scope.row.status==0 "
                            type="text"
                            size="small"
                            icon="el-icon-coordinate"
                            @click="edit(scope.row.id,scope.row.status)"
                            >审核
							</el-button>
							<el-button
							    v-if="$utils.have('/push/manage/detail') && scope.row.status!= 0"
							    type="text"
							    size="small"
							    icon="el-icon-s-management"
							    @click="edit(scope.row.id,scope.row.status)"
							    >详情
								</el-button>
							
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
		<edit ref="pushEdit" @onUpdate="getDataList()"></edit>
    </div>
</template>

<script>
const defaultParams = {
    pageNo:1,
    searchValue:"",	
    searchType: 1,
	status:0,	
    startTime:'',
    endTime:'',
    timeType: 1
}
import Edit from './edit/index.vue';
export default {
	components:{Edit},
    data(){
        return{
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
				searchType: this.$route.query.searchType || 1,
                searchValue: this.$route.query.searchValue || '',
                status: this.$route.query.status || 0,
                startTime: this.$route.query.startTime || '',
                endTime: this.$route.query.endTime || '',
            },
            listLoading: true,
            datetimerange:[this.$route.query.startTime || '' , this.$route.query.endTime || ''],

            
        }
    },
    computed:{
        
    },
    mounted() {
        this.getDataList();
    },
    methods:{
        //获取列表
        getDataList() {
            this.params = {
                ...this.params,
                startTime:this.datetimerange && this.datetimerange[0] || '',
                endTime:this.datetimerange && this.datetimerange[1] || ''
            }
            this.listLoading = true;
            this.$request({
                url: "/push/manage/list",
                method: "POST",
                data: {
                    ...this.params,
                },
            })
			.then((res) => {
				const { state, msg, result } = res.data;
				if ( state == 1 && result) {
					this.data = result;
					this.dataList = result.result || [];
                    
				} else {
                    this.data = null;
					this.dataList = [];
					this.$message.error(msg || "请求失败");
				}
			})
			.catch(() => {
				this.$message.error("请求错误");
			})
			.finally(() => {
				this.listLoading = false;
			});
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.datetimerange = [];
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        //编辑
        edit(id,status){
            this.$refs.pushEdit.show(id,status);
        }
        
    }
}
</script>